import React, { forwardRef, useEffect, useLayoutEffect } from "react";
import SideSheet from "@acadia-ui/sidesheet";
import Filter from "./FilterV2/FilterV2";

export const fullFilterAlgorithm = ({ handleFilter, config, data, dataTableApi, filterOptions, hierarchyLevel }) => {
	data = dataTableApi?.current?.dataProvider?.data || data;
	const statusAPINames = ["Prisma Status", "DV360 Status", "TM Status"];
	const filteredValues = [];
	const searchValue = dataTableApi?.current?.dataProvider?.searchQuery || "";
	const dataToFilter = searchValue !== "" ? dataTableApi?.current?.dataProvider.doSearch(data, searchValue, []) : data;
	dataToFilter.forEach((row) => {
		let nonMatchingValue = false;
		filterOptions
			.filter((option) => {
				return option.dataKey !== null;
			})
			.forEach((option) => {
				if (nonMatchingValue !== true) {
					if (!statusAPINames.includes(option.dataKey.Label)) {
						if (option.dataKey.DataType === "Select") {
							if (option.dataKey.Name === "IsDraft") {
								const selectedDraftStatuses = option?.dataValue?.map?.(({ OptionID }) => OptionID) || [];
								const rowDraftStatus = row.IsDraft === "True" ? "True" : "False";

								if (!selectedDraftStatuses.includes(rowDraftStatus)) {
									nonMatchingValue = true;
								}
							}
							if (
								option.dataKey.Name !== "IsDraft" &&
								option.dataKey.Name !== "ParentDescription" &&
								(!row[option.dataKey.Name] || !option?.dataValue?.map?.(({ OptionLabel }) => OptionLabel)?.includes(row[option.dataKey.Name]))
							) {
								nonMatchingValue = true;
							}
							if (option.dataKey.Name === "ParentDescription") {
								const parentOptionIDs = option.dataValue.map((value) => {
									return value.OptionID;
								});
								if (hierarchyLevel === "LineItem" && !parentOptionIDs.includes(row.InsertionOrderID)) {
									nonMatchingValue = true;
								}
								if (hierarchyLevel === "Placement") {
									const includesStandalone = parentOptionIDs.includes("STANDALONE");
									if (!parentOptionIDs.includes(row.PackageID) && row.PackageType !== "Standalone") {
										nonMatchingValue = true;
									}
									if (!includesStandalone && row.PackageType === "Standalone") {
										nonMatchingValue = true;
									}
								}
							}
						} else if (row[option.dataKey.Name] && row[option.dataKey.Name] !== "") {
							try {
								const filterDate = new Date(option.dataValue);
								const rowDate = new Date(row[option.dataKey.Name]);
								if (option.dataKey.Name === "StartDate") {
									if (filterDate > rowDate) {
										nonMatchingValue = true;
									}
								} else if (option.dataKey.Name === "EndDate") {
									if (filterDate < rowDate) {
										nonMatchingValue = true;
									}
								}
							} catch {
								console.log("error comparing dates");
							}
						} else {
							nonMatchingValue = true;
						}
					} else {
						if (option.dataKey.Label === "Prisma Status" || option.dataKey.Label === "DV360 Status") {
							if (
								!row.ExternalSystemStatusID ||
								!option?.dataValue
									?.map((key) => {
										return key.OptionID;
									})
									.includes(row.ExternalSystemStatusID)
							) {
								nonMatchingValue = true;
							}
						}
						if (option.dataKey.Label === "TM Status") {
							// Consider it a draft if the TraffickingPlacementStatusID is an empty string
							const emptyStringDraftMatch =
								row.TraffickingPlacementStatusID === "" &&
								option.dataValue.find((key) => {
									return key.OptionID === "1";
								});
							if (
								!option?.dataValue
									?.map((key) => {
										return key.OptionID;
									})
									.includes(row.TraffickingPlacementStatusID) &&
								!emptyStringDraftMatch
							) {
								nonMatchingValue = true;
							}
						}
					}
				}
			});

		// Keep unsaved edits visible until the user saves or cancels.
		if (row.isEdited || row.UniqueID?.includes("duplicate")) {
			nonMatchingValue = false;
		}

		if (nonMatchingValue === false) {
			filteredValues.push(row);
		}
	});
	// this.setState({
	// 	previousFilterOptions: JSON.parse(JSON.stringify(this.state.filterOptions))
	// });
	handleFilter?.(filteredValues, true, filterOptions);
	return filteredValues;
};

const FullFiltersSidesheet = forwardRef((props, ref) => {
	const { data, config, handleFilter, hierarchyLevel, filterOptions, displayPrismaStatusFilter, TMEnabled, ...rest } = props;

	useLayoutEffect(() => {
		if (hierarchyLevel === "Placement") {
			setTimeout(() => {
				let page = null;
				if (ref?.current?.dataProvider?.currentPage) {
					page = ref.current.dataProvider.currentPage;
				}
				ref?.current?.dataProvider?.filter(ref?.current?.toolbarApi?.current?.filterValues || []);
				if (ref?.current?.dataProvider && page !== null) {
					ref.current.dataProvider.currentPage = page;
					ref.current.dataProvider.update?.();
				}
			}, 100);
		} else {
			if (filterOptions?.length) {
				const appliedFilters = filterOptions?.reduce((acc, curr, index) => ({ ...acc, [index]: curr }), {});
				setTimeout(() => {
					fullFilterAlgorithm({ handleFilter, config, data, dataTableApi: ref, filterOptions, hierarchyLevel });
					setTimeout(() => {
						ref?.current?.toolbarApi?.current?.setFilterValues?.(appliedFilters);
						ref?.current?.dataProvider?.filter(filterOptions || []);
					}, 200);
				}, 200);
			}
		}
	}, []);

	return (
		<SideSheet {...rest} headline="Filters" actionSetProps={{ actionsRight: <div id={`${hierarchyLevel}_footerActions`} className="footerActions" /> }}>
			<Filter
				onClose={rest.onClose}
				filterOptions={filterOptions || Object.values(ref?.current?.toolbarApi?.current?.filterValues || {}) || []}
				hierarchyLevel={hierarchyLevel}
				config={config}
				data={data}
				filterEnabled={true}
				searchValue={""}
				dataTableApi={ref}
				handleFilter={(...args) => {
					const appliedFilters = args?.[2]?.reduce((acc, curr, index) => ({ ...acc, [index]: curr }), {}) || {};
					handleFilter?.(...args);
					setTimeout(() => {
						ref?.current?.toolbarApi?.current?.setFilterValues?.(appliedFilters);
						ref?.current?.dataProvider?.filter(args?.[2] || []);
					}, 100);
					rest.onClose();
				}}
				statusFilter={
					displayPrismaStatusFilter === true || TMEnabled === true
						? {
								prismaEnabled: displayPrismaStatusFilter === true,
								GCMEnabled: TMEnabled === true,
								DV360Enabled: false
							}
						: false
				}
				// showHideColumnsProps={showHideColumnsProps}
			/>
		</SideSheet>
	);
});

export default FullFiltersSidesheet;
